import React, { useCallback, useEffect, useState } from 'react';
import logo from '../../../assets/images/brand_alan_app_site/header/alan-logo-medium.svg';
import logoIconWhiteImg from '../../../assets/images/brand_alan_app_site/header/alan-logo-medium-text-and-icon.svg';
import items from '../../../const/menuItems';
import { Link } from 'react-router';
import _ from 'lodash';

/* eslint-disable */
//#region Animated header helpers

var Strut = {
    random: function (e, t) {
        return Math.random() * (t - e) + e;
    },
    arrayRandom: function (e) {
        return e[Math.floor(Math.random() * e.length)];
    },
    interpolate: function (e, t, n) {
        return e * (1 - n) + t * n;
    },
    rangePosition: function (e, t, n) {
        return (n - e) / (t - e);
    },
    clamp: function (e, t, n) {
        return Math.max(Math.min(e, n), t);
    },
    queryArray: function (e, t) {
        return t || (t = document.body), Array.prototype.slice.call(t.querySelectorAll(e));
    },
    ready: function (e) {
        document.readyState !== "loading" ? e() : document.addEventListener("DOMContentLoaded", e);
    }
};

function globalNavDropdowns(e) {
    var t = this;
    this.container = document.querySelector(e), this.root = this.container.querySelector(".navRoot"), this.primaryNav = this.root.querySelector(".primary"), this.primaryNavItem = this.root.querySelector(".primary .rootLink:last-child"), this.secondaryNavItem = this.root.querySelector(".secondary .rootLink:first-child"), this.checkCollision(), window.addEventListener("load", this.checkCollision.bind(this)), window.addEventListener("resize", this.checkCollision.bind(this)), this.container.classList.add("noDropdownTransition"), this.dropdownBackground = this.container.querySelector(".dropdownBackground"), this.dropdownBackgroundAlt = this.container.querySelector(".alternateBackground"), this.dropdownContainer = this.container.querySelector(".dropdownContainer"), this.dropdownArrow = this.container.querySelector(".dropdownArrow"), this.dropdownRoots = Strut.queryArray(".hasDropdown", this.root), this.dropdownSections = Strut.queryArray(".dropdownSection", this.container).map(function (e) {
        return {
            el: e,
            name: e.getAttribute("data-dropdown"),
            content: e.querySelector(".dropdownContent")
        };
    });
    var n = window.PointerEvent ? {
        end: "pointerup",
        enter: "pointerenter",
        leave: "pointerleave"
    } : {
        end: "touchend",
        enter: "mouseenter",
        leave: "mouseleave"
    };
    this.dropdownRoots.forEach(function (e, r) {
        e.addEventListener(n.end, function (n) {
            n.preventDefault(), n.stopPropagation(), t.toggleDropdown(e);
        }), e.addEventListener(n.enter, function (n) {
            if (n.pointerType == "touch") return;
            t.stopCloseTimeout(), t.openDropdown(e);
        }), e.addEventListener(n.leave, function (e) {
            if (e.pointerType == "touch") return;
            t.startCloseTimeout();
        });
    }), this.dropdownContainer.addEventListener(n.end, function (e) {
        e.stopPropagation();
    }), this.dropdownContainer.addEventListener(n.enter, function (e) {
        if (e.pointerType == "touch") return;
        t.stopCloseTimeout();
    }), this.dropdownContainer.addEventListener(n.leave, function (e) {
        if (e.pointerType == "touch") return;
        t.startCloseTimeout();
    }), document.body.addEventListener(n.end, function (e) {
        Strut.touch.isDragging || t.closeDropdown();
    });
}

//#endregion

class MenuItem extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { menuItem, target, classes } = this.props;
        const { href, path } = menuItem;
        const urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(href);

        if (urlParts[1] && urlParts[1] === window.location.host) {
            return <Link to={`/${path}`}
                target={target}
                className={classes}>
                {this.props.children}
            </Link>;
        }

        return <a href={href}
            target={target}
            className={classes}>
            {this.props.children}
        </a>;
    }
}

function PlatformSubMenu({ name, type }) {

    const [isPlatformPage, setIsPlatformPage] = useState(false);

    useEffect(() => {
        const curPathname = window.location.pathname.replace('/', '');
        const isPlatformPage = curPathname === items.platform.path;
        setIsPlatformPage(isPlatformPage);
    }, []);

    const platformLinkClicCb = useCallback((hashId, e) => {
        if (isPlatformPage) {
            let topPos = 0;
            const section = document.querySelector(`[data-anchor=${hashId}]`);
            if (section) {
                topPos = section.offsetTop;
            }
            $('html, body').animate({
                scrollTop: topPos - 100
            }, 1000);
        }
    });
    return (
        <div className={`sub-menu ${type} experience-popup`}>
            {name &&
                <div className={`sub-menu_name`}>
                    <div className={`sub-menu_name_text`}>{name}</div>
                </div>}
            <div className="experience-popup-top-col">
                <div className="">
                    <a href={isPlatformPage ? undefined : `${items.platform.href}#alan-studio`}
                        onClick={isPlatformPage ? (e) => platformLinkClicCb('alan-studio', e) : undefined}
                        className="sub-menu-item with-info">
                        <div className="sub-menu-item_content">
                            <div className="big-icon alan-studio-icon" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Alan AI Studio
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Web-based IDE for dialog design
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={isPlatformPage ? undefined : `${items.platform.href}#alan-cloud`}
                        onClick={isPlatformPage ? (e) => platformLinkClicCb('alan-cloud', e) : undefined}
                        className="sub-menu-item with-info">
                        <div className="sub-menu-item_content">
                            <div className="big-icon alan-cloud-icon" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Alan AI Cloud
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Voice AI-backend
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={isPlatformPage ? undefined : `${items.platform.href}#alan-client`}
                        onClick={isPlatformPage ? (e) => platformLinkClicCb('alan-client', e) : undefined}
                        className="sub-menu-item with-info">
                        <div className="sub-menu-item_content">
                            <div className="big-icon alan-client-icon" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Alan Client SDK
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Swift integration with any app
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div className="experience-popup-content">
                <div className="sub-menu-item-sep with-padding " style={{ margin: '8px auto' }} />
                <div className="experience-popup-col">
                    <a href={`${items.docs.href}/client-api/ios/ios-api`} target="_blank"
                        className="sub-menu-item with-info">
                        <div className="sub-menu-item_content">
                            <div className="big-icon ios-icon" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    iOS
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Works with Swift and Objective&#8209;C frameworks
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${items.docs.href}/client-api/android/android-api`} target="_blank"
                        className="sub-menu-item with-info">
                        <div className="sub-menu-item_content">
                            <div className="big-icon android-icon" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Android
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Use with Android, Java, and Kotlin SDKs
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${items.docs.href}/client-api/web/web-api`} target="_blank"
                        className="sub-menu-item with-info">
                        <div className="sub-menu-item_content">
                            <div className="big-icon web-icon" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Web
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Bring voice to any website with the Alan Web SDK
                                </div>
                            </div>
                        </div>
                    </a>
                    <div className="sub-menu-item-sep with-padding " style={{ margin: '8px auto' }} />
                    <MenuItem menuItem={items.sap}
                        classes="sub-menu-item with-info humburger-only">
                        <div className="sub-menu-item_content">
                            <div className="big-icon sap-icon with-big-logo" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    SAP
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Add an AI Assistant to your SAP application
                                </div>
                            </div>
                        </div>
                    </MenuItem>
                </div>

                <div className="experience-popup-col wrapped">
                    <MenuItem menuItem={items.sap}
                        classes="sub-menu-item with-info with-big-logo popup-only">
                        <div className="sub-menu-item_content">
                            <div className="big-icon sap-icon with-big-logo" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    SAP
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Add an AI Assistant to your SAP application
                                </div>
                            </div>
                        </div>
                    </MenuItem>
                    <a href={`${items.docs.href}/client-api/cross-platform/ionic`}
                        target="_blank"
                        className="sub-menu-item with-info with-big-logo">
                        <div className="sub-menu-item_content">
                            <div className="big-icon ionic-icon with-big-logo" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Ionic
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Build an AI Assistant for Ionic hybrid apps
                                </div>
                            </div>
                        </div>
                    </a>

                    <a href={`${items.docs.href}/client-api/cross-platform/flutter`}
                        target="_blank"
                        className="sub-menu-item with-info with-big-logo">
                        <div className="sub-menu-item_content">
                            <div className="big-icon flutter-icon with-big-logo" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Flutter
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Create an AI Assistant for any app built with Flutter by Google
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${items.docs.href}/client-api/web/electron`} target="_blank"
                        className="sub-menu-item with-info with-big-logo">
                        <div className="sub-menu-item_content">
                            <div className="big-icon electron-icon with-big-logo" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    Electron
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Alan can be integrated into cross platform desktops apps made with ElectronJS
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href={`${items.docs.href}/client-api/cross-platform/react-native`} target="_blank"
                        className="sub-menu-item with-info with-big-logo">
                        <div className="sub-menu-item_content">
                            <div className="big-icon react-native-icon with-big-logo" />
                            <div className="sub-menu-item_text-part">
                                <div className="sub-menu-item_name change-color-on-hover">
                                    React Native
                                </div>
                                <div className="sub-menu-item_description change-color-on-hover">
                                    Integrate Alan with React Native apps to run on iOS and Android
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

function CompanySubMenu({ type }) {
    return (
        <div className={`sub-menu ${type} company-popup`}>
            <MenuItem menuItem={items.aboutUs}
                classes="sub-menu-item one-line">
                <div className="small-icon about-us-menu-icon" />
                <span className="change-color-on-hover">
                    About Us
                </span>
            </MenuItem>
            <MenuItem menuItem={items.careers}
                classes="sub-menu-item one-line">
                <div className="small-icon careers-menu-icon" />
                <span className="change-color-on-hover">
                    Careers
                </span>
            </MenuItem>
            <a target="_blank" href={`${items.blog.href}`}
                className="sub-menu-item one-line">
                <div className="small-icon blog-menu-icon" />
                <span className="change-color-on-hover">
                    Blog
                </span>
            </a>
            <MenuItem menuItem={items.branding}
                classes="sub-menu-item one-line">
                <div className="small-icon brand-menu-icon" />
                <span className="change-color-on-hover">
                    Brand Assets
                </span>
            </MenuItem>
        </div>
    );
}

class ViTopMenu extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showMenu: false,
            stickyOn: false,
            movedUp: false,
            transitioned: false,
        };
    }

    componentDidMount() {
        window.onscroll = this.throttledScroll;

        this.throttledScroll();

        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    throttledScroll = _.throttle(() => {

        if (!this._isMounted) return;

        const {
            stickyOn,
        } = this.state;

        if (window.scrollY > 120) {
            if (!stickyOn) {
                this.setState({ stickyOn: true });
            }
        } else {
            if (stickyOn) {
                this.setState({ stickyOn: false });
            }
        }
    }, 50);

    openMenu = () => {
        this.setState({ showMenu: true });
        $('body').toggleClass('fixed');
    }

    closeMenu = () => {
        this.setState({ showMenu: false });
        $('body').toggleClass('fixed');
    }

    renderMenuItem(menuItem, classes, isBlank, noLink, data) {
        const { selectedPage, white, transparent } = this.props;
        const { stickyOn } = this.state;
        const { href, title, path } = menuItem;
        let itemClass = `header_menu_item ${classes} ${selectedPage === path && 'selected'}`;

        if (transparent) {
            itemClass += ' transparent';
        }
        if (white) {
            itemClass += ' white';
        }
        if (stickyOn) {
            itemClass += ' sticky-on';
        }

        const urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(href);

        if (noLink) {
            return <div className="menu-item-holder">
                <div
                    className={`${itemClass} default-cursor`}>
                    {title}
                </div>
            </div>;
        }

        if (urlParts[1] && urlParts[1] === window.location.host) {
            return <Link to={`/${path}`}
                target={isBlank ? '_blank' : ''}
                rel={isBlank ? 'noreferrer noopener' : ''}
                className={itemClass}>
                {title}
            </Link>;
        }

        return <a href={href}
            target={isBlank ? '_blank' : ''}
            rel={isBlank ? 'noreferrer noopener' : ''}
            className={itemClass}>
            {title}
        </a>;
    }

    renderExtendedMenuItem(menuItem, classes, isBlank, data) {
        return <div className="header_menu_item-popup rootLink">
            <div className="hasDropdown menu-service-item" data-dropdown={data}>
                {this.renderMenuItem(menuItem, classes, isBlank, menuItem.path !== items.platform.path ? true : false, data)}
            </div>
        </div>;
    }

    renderOverlayMenuItem(menuItem, classes, isBlank) {
        return this.renderMenuItem(menuItem, classes + ' header_menu_item_overlay', isBlank);
    }

    render() {
        const {
            transparent,
        } = this.props;

        const {
            showMenu,
            stickyOn,
            transitioned,
            movedUp
        } = this.state;

        let headerClass = 'header globalNav';
        const overlayClass = 'header_overlay-menu white';

        if (movedUp && !showMenu) {
            headerClass += ' moved-up';
        }

        if (transitioned && !showMenu) {
            headerClass += ' transitioned';
        }

        if (stickyOn && !showMenu) {
            headerClass += ' sticky-on';
        }

        if (transparent) {
            headerClass += ' transparent';
        }

        if (showMenu) {
            headerClass += ' no-perspective';
        }

        let alanLogoDesktop = <img src={logo} alt="Alan logo" />;

        if (transparent && !stickyOn) {
            alanLogoDesktop = <img src={logoIconWhiteImg} alt="Alan logo" />;
        }

        return (
            <div className={headerClass}>
                <div className="header_content">
                    <MenuItem menuItem={items.home}
                        classes="header_logo">
                        {alanLogoDesktop}
                    </MenuItem>
                    <MenuItem menuItem={items.home}
                        classes="header_logo medium">
                        {alanLogoDesktop}
                    </MenuItem>
                    <MenuItem menuItem={items.home}
                        classes="header_logo mobile">
                        {alanLogoDesktop}
                    </MenuItem>
                    <div className="header_menu navRoot">
                        <div className="secondary">
                            <div className="menu-item-holder">
                                {this.renderMenuItem(items.docs, 'rootLink', true)}
                            </div>
                            <div className="menu-item-holder">
                                {this.renderMenuItem(items.pricing, 'rootLink', false)}
                            </div>
                        </div>
                        <div className="dropdownRoot">
                            <div className="dropdownBackground"
                                style={{ "transform": "translateX(0px) scaleX(0.707692) scaleY(1.1075)" }}>
                                <div className="alternateBackground"
                                    style={{ "transform": "translateY(255.53px)" }}></div>
                            </div>
                            <div className="dropdownArrow"
                                style={{ "transform": "translateX(0px) rotate(45deg)" }}></div>
                            <div className="dropdownContainer">

                                <div className="dropdownSection left" data-dropdown="platform">
                                    <div className="dropdownContent">
                                        <PlatformSubMenu type="in-popup" />
                                    </div>
                                </div>

                                <div className="dropdownSection right" data-dropdown="company">
                                    <div className="dropdownContent">
                                        <CompanySubMenu type="in-popup" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className={`header_menu_hamburger_item ${showMenu && 'hidden'}`}
                        onClick={this.openMenu}></div>

                    <div className={`${overlayClass} ${!showMenu && 'hidden'}`}>
                        <div className="header_overlay-menu_header">
                            <MenuItem menuItem={items.home}
                                classes="logo">
                                <img src={logo} alt="Alan logo" onClick={this.closeMenu} />
                            </MenuItem>
                            <div className="header_menu_hamburger_item_close"
                                onClick={this.closeMenu}></div>
                        </div>
                        <div className={`header_overlay-menu_items`} onClick={this.closeMenu}>
                           
                            <div className="sub-menu-item-sep"
                                style={{ margin: '8px auto 0' }} />
                            <div className="doc-details in-menu">
                                <div className="doc-links-col">
                                    <MenuItem menuItem={items.pricing}
                                        classes="doc-link">
                                        {items.pricing.title}
                                    </MenuItem>
                                </div>
                                
                               
                                <div className="doc-links-col">
                                    <MenuItem menuItem={items.docs}
                                        target="_blank"
                                        classes="doc-link">
                                        {items.docs.title}
                                    </MenuItem>
                                </div>
                            </div>
                            <div className="sub-menu-item-sep"
                                style={{ margin: '8px auto 0' }} />
                            <span className="sign-in-item">
                                <div className="sign-in-item_content">
                                    <a target="_blank" rel="noreferrer noopener" href={`${items.signIn.href}`} className="sign-in-item_btn g-track-login">
                                        Sign In
                                    </a>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViTopMenu;